import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_EDIT_BEAT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EditBeat = lazy(() =>
  import('../../../screensComponents/Organization/Beats/EditBeat')
    .then(module => ({default: module.EditBeat})));

const EditBeatNavigation = [
  {
    path: ROUTE_EDIT_BEAT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditBeat />
      </Suspense>
    ),
  },
];

export default EditBeatNavigation;
